import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'ramda'

import { useDispatch } from 'react-redux'
import { addHarness } from 'actions/feature/harnesses'
import { getIsPreCreateFeature } from 'selectors/feature/features'

import strings from 'utils/strings'
import { formatIdAttribute } from 'utils/harnesses'

import * as yup from 'yup'

import { useMakeSelector, useSelector } from 'hooks/redux'
import {
  makeGetHarnessPins,
  makeGetHarnessesByModule,
} from 'selectors/feature/harnesses'
import { getFeatureModuleName } from 'selectors/feature/featureMetadata'
import { getIsEditing } from 'selectors/navigator'

import { Table, Header } from 'components/patterns'
import withStyle, {
  StyledSelectMenu,
  StyledDiv,
  StyledMenuItem,
  StyledRevision,
} from './HarnessTable.style'

const columns = [
  {
    key: 'cavity',
    title: strings.cavity,
    dataIndex: 'pin',
  },
  {
    key: 'type',
    title: strings.type_title,
    dataIndex: 'cavityType',
  },
  {
    key: 'connector',
    title: strings.connector,
    dataIndex: 'connector',
  },
  {
    key: 'circuit_name',
    title: strings.circuit_name,
    dataIndex: 'circuit',
  },
  {
    key: 'wire_gauge',
    title: strings.wire_gauge,
    dataIndex: 'wireGauge',
  },
  {
    key: 'color',
    title: strings.color,
    dataIndex: 'wireColor',
  },
]

const formatOptions = map((item) => ({
  key: formatIdAttribute(item),
  value: formatIdAttribute(item),
  title: formatTitleAttribute(item),
}))

const formatTitleAttribute = (item) => {
  if (!item) return null
  const { partNumber, revision } = item
  if (revision === '-') return partNumber
  return (
    <StyledMenuItem>
      <span>{partNumber}</span>
      {revision && (
        <StyledRevision size="small">{`${strings.rev} ${revision}`}</StyledRevision>
      )}
    </StyledMenuItem>
  )
}

const HarnessTable = ({ id, className, onAdd }) => {
  const dispatch = useDispatch()
  const isPreCreate = useSelector(getIsPreCreateFeature)
  const isEditing = useSelector(getIsEditing)
  const harnessPins = useMakeSelector(makeGetHarnessPins, { id })
  const harnessesOptions = useMakeSelector(makeGetHarnessesByModule)
  const featureModuleName = useSelector(getFeatureModuleName)
  const sortedHarnessesOptions = harnessesOptions.sort((a, b) =>
    a.partNumber > b.partNumber ? 1 : -1
  )

  const handleAdd = (newHarnessId) => {
    onAdd(newHarnessId)
    dispatch(addHarness(newHarnessId))
  }
  const showEditingSelectMenu = id === null && (isEditing || isPreCreate)

  return (
    <div className={className}>
      <Table
        dataSource={harnessPins}
        columns={columns}
        rowKey="pin"
        showEmptyText={!isEditing}
      />
      {showEditingSelectMenu && (
        <StyledDiv>
          <Header type="h4">
            {strings.harnesses_compatible_with_module(featureModuleName)}
          </Header>
          <StyledSelectMenu
            onChange={handleAdd}
            options={formatOptions(sortedHarnessesOptions)}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => {
              // input is user entered string
              const optionValue = option.key.split('+')[0]
              const result = optionValue.indexOf(input) >= 0
              return result
            }}
            value={id}
            name={strings.harnesses}
            rules={yup.string().nullable()}
          />
        </StyledDiv>
      )}
    </div>
  )
}

HarnessTable.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onAdd: PropTypes.func,
}

export default withStyle(HarnessTable)
